import { Injectable } from "@angular/core";
import { Platform } from "@angular/cdk/platform";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { timer } from "rxjs";
import { take } from "rxjs/operators";
import { PromptComponent } from "../common/prompt/prompt.component";
import { MobileService } from "./mobile.service";

@Injectable({
  providedIn: "root",
})
export class PwaService {
  private promptEvent: any;

  constructor(
    private bottomSheet: MatBottomSheet,
    private platform: Platform,
    private mobileService: MobileService
  ) {}

  public initPwaPrompt() {
    const isShown = localStorage.getItem("isInstallPromptShown") === "true";
    const isMobile = this.mobileService.isMobileApp;

    if (isShown || isMobile) {
      return;
    }
    
    if (this.platform.ANDROID) {
      this.openPromptComponent("android");
      // window.addEventListener("beforeinstallprompt", (event: any) => {
      //   event.preventDefault();
      //   this.promptEvent = event;
      //   this.openPromptComponent("android");
      // });
    }
    if (this.platform.IOS) {
      const isInStandaloneMode =
        "standalone" in window.navigator && window.navigator["standalone"];
      if (!isInStandaloneMode) {
        // Show the install prompt.
        // this.openPromptComponent("ios");
      }
    }
  }

  private openPromptComponent(mobileType: "ios" | "android") {
    localStorage.setItem("isInstallPromptShown", "true");
    timer(5000)
      .pipe(take(1))
      .subscribe(() => {
        if (!this.mobileService.isMobileApp) {
          this.bottomSheet.open(PromptComponent, {
            data: { mobileType, promptEvent: this.promptEvent },
          });
        }
      });
  }
}
